import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { history } from '../../../../redux/store';
import Inputs from '../../../../components/mui/Inputs';
import Layout from '../../../../components/mui/Layout';
import { setForgotPassword } from '../../services';
import { setIsLoadingForm } from '../../redux/actions/forgotPasswordAction';
import { swalSuccess, swalError } from '../../../../hooks/useSweetAlert';
import { describeAuthError } from '../../services/authErrors';
import { initialValuesForgotPassword as initialValues } from '../../../../helpers/variablesInitialValues';

const FormComponent = () => {
	const dispatch = useDispatch();
	const isLoadingForm = useSelector( ({ forgotPassword }) => forgotPassword.isLoadingForm);
	const inFlight = useRef(false);
	
	/**
	 *
	 * @description Validation schema
	 * @return object
	 *
	 */
	const validationSchema = () => (
		Yup.object({
			email: Yup.string()
			.email('El email no es válido')
			.required('El email es requerido')
		})
	);
	
	/**
	 *
	 * @description Execute submit of the form
	 * @param values
	 * @param resetForm
	 * @param setValues
	 * @return dispatch
	 *
	 */
	const hanbleSubmit = async (values, { resetForm, setValues }) => {
		if (inFlight.current) return;
		inFlight.current = true;
		await dispatch( setIsLoadingForm(true) );
	
		try {
			const { data } = await setForgotPassword(values);
			
			if (data.status === 200) {
				resetForm({ values: initialValues});
				setValues(initialValues);
				await swalSuccess('Solicitud exitosa', data.data);
				await history.push('/');
			}
		} catch (error) {
			await swalError(describeAuthError(error).html);
		} finally {
			inFlight.current = false;
			await dispatch( setIsLoadingForm(false) );
		}
	};
	
	/**
	 *
	 * @description Submit with the value really in the input: browsers may
	 * autofill the e-mail without firing change events.
	 * @return void
	 *
	 */
	const submitCurrentValues = (formik) => async (event) => {
		event.preventDefault();
		const field = event.currentTarget.elements.email;
		const current = { ...formik.values, email: field ? field.value : formik.values.email };
		await formik.setValues(current, false);
		const errors = await formik.validateForm(current);
		formik.setTouched({ email: true }, false);
		if (Object.keys(errors).length === 0) {
			await hanbleSubmit(current, formik);
		}
	};
	
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={hanbleSubmit}
		>
			{(formik) => {
				const { values, errors, touched, handleChange, handleBlur } = formik;
				return (
				<form noValidate onSubmit={submitCurrentValues(formik)}>
					<div className="row">
						<div className="col-sm-12 mb-2">
							<Inputs.TextBox
								type="email"
								id="legacy-forgot-email"
								name="email"
								autoComplete="username"
								inputProps={{ autoCapitalize: 'none', autoCorrect: 'off', spellCheck: false }}
								label="Email"
								placeholder="Ingrese email..."
								value={values.email}
								onBlur={handleBlur}
								onChange={handleChange}
								hasError={errors.email && touched.email ? true : false}
								errorMessage={errors.email && touched.email ? errors.email : ''}
								className="font-family-roboto-medium fs-6 text-dark w-100"
							/>
						</div>
						<div className="col-sm-12">
							<Inputs.LoadingButton
								isDisabled={isLoadingForm}
								isLoading={isLoadingForm}
								isLoadingPosition="start"
								startIcon={<Layout.Icons.MailIcon height={18} width={18} />}
								label="Cambiar contraseña"
								type="submit"
								className="bg-primary font-family-roboto-regular fs-6 text-capitalize w-100"
							/>
						</div>
					</div>
				</form>
				);
			}}
		</Formik>
	);
};

export default FormComponent;
